
// verifiCondition_session: Esta función verifica si se cumple la condición para que se 
// renderice el componente.
export const verifyCondition_session = ( filesSelected, socketConnected, sessionsChatSelected ) => {
    let condition = (
        filesSelected.length === 0 && 
        socketConnected && 
        sessionsChatSelected.length > 0 
    );
    return condition;
}
